module.exports = __webpack_public_path__ + "static/img/deliverables_bg.afe90f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gene_second/deliverables_bg.png
// module id = rB+7
// module chunks = 16